<div class="valg-datepicker" [class.valg-datepicker__active]="isDatepickerOpen">
  <ng-container *ngTemplateOutlet="input"></ng-container>
  <button type="button" (click)="toggleCalendar()" class="valg-datepicker-button" valgButton cdkOverlayOrigin 
  #trigger="cdkOverlayOrigin" [disabled]="disabled">
    <mat-icon [svgIcon]="SvgIcon.Calendar"></mat-icon>
    <span class="sr-only">{{ 'datepicker.button.open' | translate }}</span>
  </button>
</div>


<ng-template #input>
  <ng-content
    select="input[valgInput]"
  ></ng-content>
</ng-template>



<ng-template
  cdkScrollable
  cdkConnectedOverlayPanelClass="date-picker__calendar-overlay"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPositions]="overlayConnectedPositions"
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="backdrop"
  (backdropClick)="hideCalendar()"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOverlayTriggered"
  (open)="datepickerOpened()">
  <div class="date-picker__calendar" role="dialog" #datepicker (keydown.escape)="handleEscapeFromCalendar($event)" aria-modal="true" [class.date-picker__calendar--active]="isMenuOverlayTriggered" [attr.aria-describedby]="id+'__guide'">
    
    <div [tabindex]="!showCalendarMonthPicker && !showCalendarYearPicker ? null : '-1'" role="presentation" class="date-picker__calendar__date-picker" (keydown.Tab)="datePickerTabEventHandler.tabAhead($event)" (keydown.shift.Tab)="datePickerTabEventHandler.tabBack($event)" *ngIf="!showCalendarMonthPicker && !showCalendarYearPicker">
      <div class="date-picker__calendar__row">
        <div class="date-picker__calendar__cell date-picker__calendar__cell--center-items">
          <button type="button" class="date-picker__calendar__previous-year" (click)="displayPreviousYear()" attr.aria-label="{{ 'datepicker.navigate_year_back' | translate }}" *ngIf="!isPreviousButtonsDisabled()">
            <mat-icon [svgIcon]="SvgIcon.ChevronDoubleLeft"></mat-icon></button>
        </div>
        <div class="date-picker__calendar__cell date-picker__calendar__cell--center-items">
          <button type="button" class="date-picker__calendar__previous-month" (click)="displayPreviousMonth()" attr.aria-label="{{ 'datepicker.navigate_month_back' | translate }}" *ngIf="!isPreviousButtonsDisabled()">
            <mat-icon [svgIcon]="SvgIcon.ChevronLeft"></mat-icon></button>
        </div>
        <div class="date-picker__calendar__cell date-picker__calendar__month-label">
          <button type="button" class="date-picker__calendar__month-selection" (click)="displayMonthSelection()" attr.aria-label="{{ focusedMonth | translate }}. {{ 'datepicker.select_month' | translate }}">{{ focusedMonth | translate }}</button>
          <button type="button" class="date-picker__calendar__year-selection" (click)="displayYearSelection()" attr.aria-label="{{ calendarFocusedDate.getFullYear() }} {{ 'datepicker.select_a_year' | translate }}.">{{ calendarFocusedDate.getFullYear() }}</button>
        </div>
        <div class="date-picker__calendar__cell date-picker__calendar__cell--center-items">
          <button type="button" class="date-picker__calendar__next-month" (click)="displayNextMonth()" *ngIf="!isNextButtonsDisabled()" attr.aria-label="{{ 'datepicker.navigate_month_forward' | translate }}" >
            <mat-icon [svgIcon]="SvgIcon.ChevronRight"></mat-icon></button>
        </div>
        <div class="date-picker__calendar__cell date-picker__calendar__cell--center-items">
          <button type="button" class="date-picker__calendar__next-year" (click)="displayNextYear()" *ngIf="!isNextButtonsDisabled()" attr.aria-label="{{ 'datepicker.navigate_year_forward' | translate }}" >
            <mat-icon [svgIcon]="SvgIcon.ChevronDoubleRight"></mat-icon></button>
        </div>
      </div>
      <table class="date-picker__calendar__table" role="presentation">
        <thead>
          <tr>
            <ng-container *ngFor="let d of weekdays">
              <th class="date-picker__calendar__day-of-week" scope="col" [attr.aria-label]="d | translate">{{ d | translate | slice : 0 : 1 }}</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let w of calendarData">
              <td *ngFor="let d of w">
                <button 
                  type="button" [tabindex]="isDateInCurrentMonth(d.value) ? null : '-1'" 
                  (click)="selectDate(d.value)"
                  (keydown)="onDateKeydown($event, d.value)"
                  class="date-picker__calendar__date"
                  role="option"
                  [attr.data-day]="d.day"
                  [attr.data-month]="d.month" 
                  [attr.data-year]="d.year" 
                  [attr.data-value]="d.value" 
                  [attr.aria-label]="'datepicker.readable_date' | translate : d.label" 
                  [attr.aria-selected]="d.selected" 
                  [disabled]="d.disabled ? true : null"
                  [class.date-picker__calendar__date--selected]="d.selected"
                  [class.date-picker__calendar__date--current-month]="isDateInCurrentMonth(d.value)"
                  [class.date-picker__calendar__date--focused]="d.focused"
                  [tabindex]="d.focused ? '0' : '-1'"
                  >{{d.day}}</button>
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div [tabindex]="showCalendarMonthPicker ? null : '-1'" class="date-picker__calendar__month-picker" (keydown.Tab)="monthPickerTabEventHandler.tabAhead($event)" (keydown.shift.Tab)="monthPickerTabEventHandler.tabBack($event)" *ngIf="showCalendarMonthPicker">
      <table class="date-picker__calendar__table" role="presentation">
        <tbody>
          <tr *ngFor="let r of calendarMonths">
            <td *ngFor="let m of r">
              <button 
              type="button" 
              (keydown)="onMonthKeydown($event, m.value)" 
              class="date-picker__calendar__month"  
              (click)="selectMonth(m.value)" 
              [attr.aria-selected]="m.selected"
              [attr.data-value]="m.value"
              [class.date-picker__calendar__month--selected]="m.selected"
              [class.date-picker__calendar__month--focused]="isMonthFocused(m.value)"
              [tabindex]="isMonthFocused(m.value) ? '0' : '-1'"
              >{{ m.label | translate }}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div [tabindex]="showCalendarYearPicker ? null : '-1'"
      class="date-picker__calendar__year-picker" 
      (keydown.Tab)="yearPickerTabEventHandler.tabAhead($event)" 
      (keydown.shift.Tab)="yearPickerTabEventHandler.tabBack($event)" 
      *ngIf="showCalendarYearPicker">
      <table class="date-picker__calendar__table" role="presentation">
        <tbody>
          <tr>
            <td>
              <button 
              type="button" 
              class="date-picker__calendar__previous-year-chunk" 
              (click)="displayPreviousYearChunk()" 
              attr.aria-label="{{ 'navigate_12_back' | translate }}" 
              *ngIf="!isPreviousYearChunkDisabled()"
              ><mat-icon [svgIcon]="SvgIcon.ArrowLeftDefault"></mat-icon></button>
            </td>
            <td colspan="3">
              <table class="date-picker__calendar__table" role="presentation">
                <tbody>
                  <tr *ngFor="let r of calendarYears">
                    <td *ngFor="let y of r">
                      <button 
                        type="button" 
                        (keydown)="onYearKeydown($event, y.value)"
                        class="date-picker__calendar__year"
                        (click)="selectYear(y.value)"
                        [attr.aria-selected]="y.selected"
                        [attr.data-value]="y.value"
                        [class.date-picker__calendar__year--selected]="y.selected"
                        [class.date-picker__calendar__year--focused]="isYearFocused(y.value)"
                        [attr.aria-selected]="y.selected"          
                        [tabindex]="isYearFocused(y.value) ? '0' : '-1'"
                        [disabled]="y.disabled ? true : null"
                        >{{y.value}}</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <button 
              type="button" 
              class="date-picker__calendar__next-year-chunk" 
              (click)="displayNextYearChunk()" 
              attr.aria-label="{{ 'navigate_12_forward' | translate }}" 
              *ngIf="!isNextYearChunkDisabled()"
              ><mat-icon [svgIcon]="SvgIcon.ArrowRightDefault"></mat-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="sr-only date-picker__status" role="status" aria-live="polite" [id]="id+'__guide'">{{ datepickerStatus | translate :  datepickerStatusParameters }}</div>
  </div>
</ng-template>
